<template>
  <v-card>
    <v-toolbar flat height="50">
      <v-toolbar-title>Training & Manpower(BMET) Details</v-toolbar-title>
    </v-toolbar>
    <div v-if="project" class="pa-4">
      <v-layout row wrap>
        <v-flex md3>
          <strong>Training start date </strong><br />
          <p>{{ project.training_start_date  }}</p>
        </v-flex>
        <v-flex md3>
          <strong>Training end date</strong><br />
          <p>{{ project.training_end_date}}</p>
        </v-flex>
        <v-flex md3>
          <strong>Training & Finger Remarks</strong><br />
          <p>{{ project.training_and_finger_notes}}</p>
        </v-flex>
        <v-flex md3>
          <strong>Manpower(BMET) submit date</strong><br />
          <p>{{ project.bmet_submit_date}}</p>
        </v-flex>
      </v-layout>

      <v-layout row wrap>
        <v-flex md3>
          <strong>Manpower(BMET) Status</strong><br />
          <p>{{ valueToText(FINGER_STATUSES, project.bmet_status)  }}</p>
        </v-flex>
        <v-flex md3>
          <strong>Manpower(BMET) Remarks</strong><br />
          <p>{{ project.bmet_notes}}</p>
        </v-flex>
      </v-layout>
    </div>
  </v-card>
</template>

<script>
import {
  MEDICAL_STATUSES,
  VISA_TYPES,
  SERVICE_TYPES,
  PROJECT_OWNER,
  FINGER_STATUSES,
} from "../../mdsir/const";

import {
  valueToText,
  getTV,
  districtTV,
  upazilaTV,
  unionTV,
} from "../../mdsir/MdsirUtils";

export default {
  props: ["project"],
  data() {
    return {
      PROJECT_OWNER: PROJECT_OWNER,
      FINGER_STATUSES: FINGER_STATUSES,
    };
  },

  // computed: {},

  methods: {
    renderProp(item) {
      const { key } = item;
      let value = this.project[key];
      switch (key) {
        case "medical_status":
          value = value ? valueToText(MEDICAL_STATUSES, value) : "";
          break;
        case "service_type":
          value = value ? valueToText(SERVICE_TYPES, value) : "";
          break;
        case "trade_name":
          value = value ? valueToText(VISA_TYPES, value) : "";
          break;
        case "project_owner":
          value = value ? valueToText(PROJECT_OWNER, value) : "";
          break;

        default:
          break;
      }
      return value;
    },
    districtTV: districtTV,
    upazilaTV: upazilaTV,
    unionTV: unionTV,
    getTV: getTV,
    valueToText: valueToText,
  },

  // mounted() {},

  // watch: {},

  // beforeDestroy() {},

  // created() {},
};
</script>
